import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

/*Moduls */
import { AppRoutingModule } from './app-routing.module';

/*Components */
import { AppComponent } from './app.component';
import { HeaderComponent } from './view/header/header.component';
import { NavAppComponent } from './view/auth/nav-app/navapp.component';
import { SignInComponent } from './view/auth/signin/signin.component';
import { SignUpComponent } from './view/auth/signup/signup.component';
import { RestoreComponent } from './view/auth/restore/restore.component';
import { ConfirmUserComponent } from './view/auth/confirmUser/confirmUser.component';
import { DeleteUserComponent } from './view/auth/deleteUser/deleteUser.component';


import { PersonalComponent } from './view/personal/personal.component';
import { OnlineComponent } from './view/online/online.component';
import { EventsComponent } from './view/events/events.component';
import { StateComponent } from './view/state/state.component';
import { TracksComponent } from './view/tracks/tracks.component';
import { ReportsComponent } from './view/reports/reports.component';
import { GeozoneComponent } from './view/geozone/geozone.component';
import { ServicesComponent } from './view/services/services.component';
import { ShareRequestsComponent } from './view/share-requests/share-requests.component';

import {
  TimersListComponent,
  TimerAddComponent,
  TariffsBlockComponent,
  MainStateInfoComponent,
  StateInfoComponent,
  CommandList,
  IndicatorDeviceComponent,
  AddObjectMenuComponent,
  VideoBackgroundComponent,
  UsernameFieldComponent,
  ReportStatsItemComponent,
  GraphStatsComponent,
  ReportQualityComponent,
  PointerGraphComponent,
  ReportQualityGraphComponent,
  BitmaskField
} from './view/components';

import {
  SettingsComponent,
  AddObjectComponent,
  selectObjectComponent,
  FeedbackComponent,
  TariffModalComponent,
  UpdatePasswordModalComponent,
  ChangeObjectNameModalComponent,
  ChangeDevicePhoneModalComponent,
  ProfileModalComponent,
  SendCapchaModalComponent,
  ShareDeviceModalComponent,
  ShareDeviceConfirmModalComponent,
  ShareDeviceCancelModalComponent,
  ServiceOrderModalComponent,
  ConfirmDeletingModalComponent
} from './view/modal';


/*Services */
import {
  CachedDataService,
  AuthService,
  UserService,
  ObservableObjectsService,
  DevicesService,
  ObjectsService,
  ScreenService,
  StateService,
  CommandsService,
  SettingsService,
  MappingService,
  TariffService,
  AppService,
  GeozoneService,
  ShareDeviceService,
  ServicesService
} from '@services';


/*Guards */
import { MainGuard, AuthGuard, SignUpGuard, PersonalGuard, MainNoDeviceGuard } from './guards';

/*Directives*/
import { TooltipeDirective } from './directives/tooltip.directive';


/*Plugins */
import { BsModalModule } from 'ng2-bs3-modal';
import { ChartModule } from 'angular-highcharts';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMyDatePickerModule } from 'ngx-mydatepicker';
import { TextMaskModule } from 'angular2-text-mask';
import { NgSelectModule } from '@ng-select/ng-select';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { OwlModule } from 'ngx-owl-carousel';
import { MyDatePickerModule } from 'mydatepicker';
import { IonRangeSliderModule } from 'ng2-ion-range-slider';
import { YoutubePlayerModule } from 'ngx-youtube-player';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    NavAppComponent,
    SignInComponent,
    SignUpComponent,
    RestoreComponent,
    ConfirmUserComponent,
    DeleteUserComponent,
    FeedbackComponent,
    PersonalComponent,
    OnlineComponent,
    EventsComponent,
    StateComponent,
    TracksComponent,
    AddObjectComponent,
    selectObjectComponent,
    AddObjectMenuComponent,
    SettingsComponent,
    CommandList,
    StateInfoComponent,
    IndicatorDeviceComponent,
    MainStateInfoComponent,
    TimerAddComponent,
    TimersListComponent,
    TooltipeDirective,
    TariffsBlockComponent,
    TariffModalComponent,
    UpdatePasswordModalComponent,
    VideoBackgroundComponent,
    UsernameFieldComponent,
    ChangeObjectNameModalComponent,
    ChangeDevicePhoneModalComponent,
    ProfileModalComponent,
    ReportsComponent,
    ReportStatsItemComponent,
    SendCapchaModalComponent,
    ConfirmDeletingModalComponent,
    GraphStatsComponent,
    GeozoneComponent,
    ReportQualityComponent,
    PointerGraphComponent,
    ReportQualityGraphComponent,
    ShareDeviceModalComponent,
    ShareRequestsComponent,
    ShareDeviceConfirmModalComponent,
    ShareDeviceCancelModalComponent,
    ServiceOrderModalComponent,
    BitmaskField,
    ServicesComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    NgxMyDatePickerModule.forRoot(),
    NgbModule.forRoot(),
    MyDatePickerModule,
    ChartModule,
    ReactiveFormsModule,
    TextMaskModule,
    BsModalModule,
    NgSelectModule,
    MyDateRangePickerModule,
    OwlModule,
    IonRangeSliderModule,
    YoutubePlayerModule
  ],
  providers: [
    AuthService,
    UserService,
    CachedDataService,
    ObservableObjectsService,
    DevicesService,
    ObjectsService,
    ScreenService,
    MappingService,
    StateService,
    CommandsService,
    SettingsService,
    TariffService,
    AppService,
    GeozoneService,
    ShareDeviceService,
    ServicesService,
    MainGuard,
    AuthGuard,
    SignUpGuard,
    PersonalGuard,
    MainNoDeviceGuard],
  bootstrap: [AppComponent],
  entryComponents: [
    AddObjectMenuComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts